$(document).ready(function () {
    initCustomDropdown();
});

window.initCustomDropdown = function () {
    initCustomDropdown();
};

function initCustomDropdown() {
    if ($('.initialize-custom-dropdown').material_select !== undefined) {
        $('.initialize-custom-dropdown').material_select("destroy");
    }

    $('.initialize-custom-dropdown').each(function(){
        if ($(this).parents('.custom-dropdown').length) {
            return;
        }

        let that = $(this),
            listTitle = '',
            selectedPrefix = '',
            classList = that.attr('data-class'),
            optionsCount = that.children('option').length,
            selectedValue = that.children('option:selected').val(),
            selectedText = that.children('option:selected').eq(0).text();

        if (classList === undefined) {
            classList = '';
        }

        if (that.data('selected-prefix')) {
            selectedPrefix = that.data('selected-prefix')
        }

        if (that.data('list-title')) {
            listTitle = that.data('list-title')
        }

        that.wrap('<div class="custom-dropdown '+ classList +'"></div>');
        that.after('<div class="custom-dropdown__select">' +
            '<span class="custom-dropdown__select-title"></span>' +
            '<span class="custom-dropdown__select-icon"></span>' +
            '</div>');

        let select = that.next('.custom-dropdown__select'),
            dropdown = select.parents('.custom-dropdown'),
            selectTitle = select.find('.custom-dropdown__select-title');

        selectTitle.text(selectedPrefix +' '+ selectedText)

        let list = $('<ul />', {
            'class': 'custom-dropdown__list',
            'data-scrollbar': true,
        }).insertAfter(select);

        let options = list.wrap('<div class="custom-dropdown__options"></div>');

        if (listTitle) {
            options.prepend('<span class="custom-dropdown__list-title">'+listTitle+'</span>');
        }

        for (let i = 0; i < optionsCount; i++) {
            let rel = that.children('option').eq(i).val(),
                text = that.children('option').eq(i).text(),
                classList = that.children('option').eq(i).attr('class');

            if (classList === undefined) {
                classList = '';
            }

            $('<li />', {
                rel: rel,
                class: rel === selectedValue ? 'active ' + classList : classList,
            }).append('<span class="text">'+text+'</span>').appendTo(list).append('<span class="icon"></span>');
        }

        let listItems = list.children('li');

        select.click(function(event) {
            event.stopPropagation();

            $('div.custom-dropdown__select.active').not(this).each(function(){
                $(this).removeClass('active').parents('.custom-dropdown').removeClass('opened');
            });
            $(this).toggleClass('active').parents('.custom-dropdown').toggleClass('opened');
        });

        listItems.click(function(event) {
            event.stopPropagation();

            that.val($(this).attr('rel')).change();

            selectTitle.text(selectedPrefix +' '+ $(this).text())

            dropdown.removeClass('opened');

            dropdown.find('.custom-dropdown__select').removeClass('active');

            listItems.removeClass('active')

            $(this).addClass('active')
        });

        $(document).on('click', function(event) {
            if ($(event.target).closest('.custom-dropdown__options').length) return;

            dropdown.removeClass('opened');

            dropdown.find('.custom-dropdown__select').removeClass('active');
        });
    });
}